import Request from './request'

const Comments  = {
  getComments(params, callback) {
    Request.post('comments/list', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  addComment(params, callback) {
    Request.post('comments/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  editComment(params, callback) {
    Request.post('comments/update', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Comments
